module.exports = __webpack_public_path__ + "static/img/b2r.ec876141.webp";